import { objectOf, arrayOf, maybe } from "@altostra/type-validations";
import { string, number, boolean } from "@altostra/type-validations/lib/primitives";

import {
  isCallingObjectInformation,
  isRuleResolution,
  isTokenUsage,
  isToolExecutionLog,
} from "../generativeAiAgentIdLogs/validators";

/** One invocation log's full document, as the detail and batch details endpoints send it. */
export const isGenerativeAiAgentIdLogsDetailResultItem = objectOf({
  invocation_id: string,
  start_time: number,
  duration: maybe(number, true),
  is_error: boolean,
  prompt: maybe(string, true),
  response_message: string,
  system_instructions: maybe(string, true),
  step_instructions: maybe(string, true),
  token_usage: maybe(isTokenUsage, true),
  tool_execution_logs: maybe(arrayOf(isToolExecutionLog), true),
  calling_object_information: maybe(isCallingObjectInformation, true),
  agent_model_name: maybe(string, true),
  agent_model_provider_name: maybe(string, true),
  thinking_level: maybe(string, true),
  braze_model_when_using_auto: maybe(string, true),
  llm_owned_by_customer: maybe(boolean, true),
  ruleset_name: maybe(string, true),
  ruleset_rules: maybe(arrayOf(string), true),
  ruleset_scope: maybe(string, true),
  step_name: maybe(string, true),
  step_id: maybe(string, true),
  rule_resolutions: maybe(arrayOf(isRuleResolution), true),
  agent_definition_version: maybe(number, true),
  fallback_value: maybe(string, true),
  braze_context_types: maybe(arrayOf(string), true),
  braze_context: maybe(string, true),
});

export const isGenerativeAiAgentIdLogsDetailResult = objectOf({
  result: isGenerativeAiAgentIdLogsDetailResultItem,
});
